import initialState from './initialState';
import { reducer as retrieveTopics } from './retrieveTopics';
import { reducer as retrieveTopicPreview } from './retrieveTopicPreview';
import { reducer as createTopic } from './createTopic';
import { reducer as retrieveDelete } from './deleteTopic';
import { reducer as categoriesReducer } from './retrieveAllCategories';
import { reducer as uploadFile } from './uploadFile';
import { reducer as retrieveAllUploadedFilesForTopic } from './retrieveAllUploadedFilesForTopic';

const reducers = [
  retrieveTopics, 
  createTopic, 
  retrieveDelete, 
  categoriesReducer,
  retrieveTopicPreview,
  uploadFile,
  retrieveAllUploadedFilesForTopic
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case 'RESET_TOPICS_STATE':
      return {
        ...state,
        ...initialState,
      };
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/topics/redux/reducer.js